/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_Products_TitleInputs */

const en_directory_builders_products_title = /** @type {(inputs: Directory_Builders_Products_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products in the preview`)
};

const zh_directory_builders_products_title = /** @type {(inputs: Directory_Builders_Products_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览中的产品`)
};

/**
* | output |
* | --- |
* | "Products in the preview" |
*
* @param {Directory_Builders_Products_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_products_title = /** @type {((inputs?: Directory_Builders_Products_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_Products_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_products_title(inputs)
	return zh_directory_builders_products_title(inputs)
});
export { directory_builders_products_title as "directory.builders.products_title" }